import { LogsFamilyEnum } from "./LogsFamilyEnum";

export enum LogsTypeEnum {
    Unknown = 0,
    Firmware = 1,
    AgentLogs = 2,
    CaosLogs = 3,
    CaosConnectorLogs = 4,
    CHWebApiLogs = 5,
    CHMonitorLogs = 6,
}

export function getLogTypesFromLogsFamily(value: LogsFamilyEnum): LogsTypeEnum[] {
    var resultList = [];
    switch (value) {
        case LogsFamilyEnum.Application:
            resultList.push(LogsTypeEnum.AgentLogs);
            resultList.push(LogsTypeEnum.CaosLogs);
            resultList.push(LogsTypeEnum.CaosConnectorLogs);
            resultList.push(LogsTypeEnum.CHWebApiLogs);
            resultList.push(LogsTypeEnum.CHMonitorLogs);
            break;
        case LogsFamilyEnum.Machine:
            resultList.push(LogsTypeEnum.Firmware);
            break;
    }
    return resultList;
}
